var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2862_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5328 12.1871C21.5328 11.3677 21.4664 10.7697 21.3225 10.1497H11.9658V13.848H17.458C17.3473 14.7671 16.7493 16.1512 15.4206 17.0813L15.4019 17.2051L18.3603 19.4969L18.5653 19.5174C20.4477 17.7789 21.5328 15.221 21.5328 12.1871Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9657 21.9312C14.6563 21.9312 16.9152 21.0453 18.5651 19.5173L15.4204 17.0812C14.5789 17.6681 13.4494 18.0777 11.9657 18.0777C9.33032 18.0777 7.0936 16.3393 6.29627 13.9365L6.1794 13.9464L3.10322 16.3271L3.06299 16.439C4.70177 19.6944 8.06795 21.9312 11.9657 21.9312Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29626 13.9366C6.08588 13.3165 5.96412 12.6521 5.96412 11.9656C5.96412 11.279 6.08588 10.6147 6.28519 9.9946L6.27962 9.86253L3.16489 7.4436L3.06298 7.49208C2.38756 8.84299 2 10.36 2 11.9656C2 13.5712 2.38756 15.0881 3.06298 16.439L6.29626 13.9366Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9657 5.85336C13.837 5.85336 15.0992 6.66168 15.819 7.33718L18.6315 4.59107C16.9042 2.9855 14.6563 2 11.9657 2C8.06795 2 4.70177 4.23672 3.06299 7.49214L6.2852 9.99466C7.0936 7.59183 9.33032 5.85336 11.9657 5.85336Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2862_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.542,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5ffee8d58d5a1872b2ed8400a7918efe.svg";
export { ForwardRef as ReactComponent };